
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { BlogPostLayout as _Default } from '@/layouts/BlogPostLayout'
import { jk } from '@/authors'
export { getStaticProps } from '@/layouts/BlogPostLayout';
const meta = {
  title: ' 2021Q3 Product Updates',
  description: `Introducing Tradly JS SDK. We are super excited to bring this to you! `,
  date: '2021-11-07T15:43:02.988Z',
  authors: [jk]
};
const slug = '2021-11-07-nov';
const tableOfContents = [{
  "title": "NextJs + Tailwind Starter Kit",
  "slug": "next-js-tailwind-starter-kit",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p>{`Introducing Tradly JS SDK. We are super excited to bring this to you!
`}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/tradly"
      }}>{`https://www.npmjs.com/package/tradly`}</a></p>
    <p>{`What’s more than a SDK that can SAVE developers time to integrate new solution!
Stripe was a big inspiration for us. Making things easier for even a junior developers to build application faster was a goal to improve developer experience. And we did it. We are excited than ever in our journey to share our Javascript SDK is ready! `}</p>
    {/*more*/}
    <p>{`In addition to this SDK, all our existing open source code will be updated with this SDK on coming weeks. Hence it’s going to be easier for developers to apply customisation with a CONFIDENCE that always the SDK has the updated APIs and it’s feature set. `}</p>
    <p>{`To show you the power of the SDK, we launched another open source kits built on #nextjs & #Tailwind (Honourable mention that Tailwind has saved 40% our front end developers time) with SDK & deployed on @vercel`}</p>
    <p>{`A headless API already saves a lot of time to launch #marketplace and #commerce apps. Adding a JS SDK means even faster development of front end apps. Launch omnichannel commerce apps with your favourite #JAMstack now. To see the demo of the starter kit build with SDK > `}<a parentName="p" {...{
        "href": "https://watchtracker.vercel.app/"
      }}>{`https://watchtracker.vercel.app/`}</a></p>
    <p>{`Or start fresh `}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Register for a FREE ACCOUNT account and get the api key `}<a parentName="li" {...{
          "href": "https://tradly.app/signup"
        }}>{`https://tradly.app/signup`}</a></li>
      <li parentName="ol">{`Fork the repository `}<a parentName="li" {...{
          "href": "https://github.com/TRADLY-PLATFORM/Butterflies"
        }}>{`https://github.com/TRADLY-PLATFORM/Butterflies`}</a></li>
      <li parentName="ol">{`Deploy on #vercel, #Clouflare or #Netlify for free to see the demo.`}</li>
    </ol>
    <p>{`This mark an important milestone in our product releases. `}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`NEW: Tailwind CSS saving 40% of your front end developer time`}</li>
      <li parentName="ol">{`NEW: Jamstack focused deployment tools make it easier than ever to launch apps. `}</li>
      <li parentName="ol">{`NEW: NextJS is a revolutionary framework to build static+dynamic together website. SEO benefits. Our design elements are componentized properly with deep thought process. So you can make changes easily. `}</li>
      <li parentName="ol">{`New SDK means saving your time to avoid API connection mistakes.`}</li>
    </ol>
    <p>{`Our next goal:`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Increase the performance of the starter kit and reaching GREEN on lighthouse performance benchmark. So your website loads faster.`}</li>
      <li parentName="ol">{`Adding seller related features in the starter kit `}</li>
      <li parentName="ol">{`Releasing few more layouts that suit to different business nature.`}</li>
    </ol>
    <_Heading level={2} id={"next-js-tailwind-starter-kit"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>NextJs + Tailwind Starter Kit</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Github Link: `}<a parentName="li" {...{
          "href": "https://github.com/TRADLY-PLATFORM/Butterflies"
        }}>{`https://github.com/TRADLY-PLATFORM/Butterflies`}</a></li>
      <li parentName="ul">{`Suitable to use as it is for event marketplace`}</li>
      <li parentName="ul">{`Deployment information in Github readme files`}</li>
    </ul>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
